/**
 * Discount Modal Component - Using new Modal component
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalTitle,
} from '../../components/ui/modal';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select';
import { Percent } from 'lucide-react';

export function DiscountModal({
  open,
  onOpenChange,
  discountType,
  setDiscountType,
  orderDiscount,
  setOrderDiscount,
}) {
  const { t } = useTranslation();

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <ModalContent size="sm">
        <ModalHeader>
          <ModalTitle className="flex items-center gap-2">
            <Percent className="h-5 w-5" />
            {t('pdv.applyDiscount')}
          </ModalTitle>
        </ModalHeader>
        <ModalBody className="space-y-4">
          <Select value={discountType} onValueChange={setDiscountType}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="value">Valor (R$)</SelectItem>
              <SelectItem value="percent">Porcentagem (%)</SelectItem>
            </SelectContent>
          </Select>
          <Input
            type="number"
            value={orderDiscount}
            onChange={(e) => setOrderDiscount(parseFloat(e.target.value) || 0)}
            placeholder={discountType === 'value' ? 'Valor em R$' : 'Porcentagem'}
            data-testid="discount-input"
          />
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" onClick={() => { setOrderDiscount(0); onOpenChange(false); }}>
            Limpar
          </Button>
          <Button onClick={() => onOpenChange(false)}>Aplicar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default DiscountModal;
